<div class="row mb-3">
  <div class="col-lg col-lg-12">
    <table class="table table-heading-5 padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="max-w-140">{{ data?.MainObject }}</td>
        <td>{{ data?.ServiceDescription }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="clearfix"></div>

<div class="row">
  <!-- URL BADGES -->
  <ng-container *ngIf="hasUrlBadges()">
    <div class="col-lg col-lg-12">
      <table class="table padding-td-15 table-borderless mt-0 mb-0 w-100">
        <tbody>
        <tr>
          <td class="text-center width-25">
            <app-rca-tag
              [tagName]="data?.MainObject"
              [active]="data?.Dev_Active"
              [inactive]="data?.Dev_InActive"
              [inactiveCount]="data?.Dev_InActive_Count"
              [type]="'DEV'"></app-rca-tag>
          </td>
          <td class="text-center width-25">
            <app-rca-tag
              [tagName]="data?.MainObject"
              [active]="data?.Flt_Active"
              [inactive]="data?.Flt_InActive"
              [inactiveCount]="data?.Flt_InActive_Count"
              [type]="'RCA-F'"></app-rca-tag>
          </td>
          <td class="text-center width-25">&nbsp;</td>
          <td class="text-center width-25">&nbsp;</td>
        </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- TYPE & MODEL -->

  <div class="col-lg col-lg-10">
    <table class="table padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="font-weight-bold max-w-140">Type:</td>
        <td>{{ data.Type }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Manufacturer:</td>
        <td>{{ data.Manufacturer }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Model:</td>
        <td>{{ data.Model }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Display Range:</td>
        <td>{{ data.DisplayRange }}</td>
      </tr>
<!--      <tr>-->
<!--        <td class="max-w-140">Func. Test progr.:</td>-->
<!--        <td>{{ data.FuncTestProgr }}</td>-->
<!--      </tr>-->
      </tbody>
    </table>
  </div>
  <div class="col-lg col-lg-2">
    <ng-container *ngIf="data.EqHubTekNo">
      <a [href]="data.EqHubTekNo" class="mb-3 float-lg-end doc-db-icon" target="_blank">
        <img src="./assets/images/icons/doc-db_icon.svg" alt="">
      </a>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="data.MainObject_Sif">
      <a
        [routerLink]="['/spas/sif-manual/overview']"
        [queryParams]=getSIFParams(data.MainObject)
        title="SIF"
        class="mb-3 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 font-weight-bold d-block"
        target="_blank">
        SIF
      </a>
      <div class="clearfix"></div>
    </ng-container>

    <ng-container *ngIf="displayNotificationIcon(data.Notifications_Status)">
      <a [ngClass]="{
        'float-lg-end fs-18 pt-0 pb-0 px-1 pe-1 d-block': true,
        'clickable': data.Notifications_Status === 1,
        'clickable-light': data.Notifications_Status === -1
        }" (click)="onOpenNotificationModal(data.MainObject)" title="Notifications">
        <i class="fa fa-tools"></i>
      </a>
    </ng-container>
  </div>
</div>

<hr>
<table class="table padding-td-15 table-borderless mb-0">
  <tbody>
  <!-- AHH -->
  <ng-container *ngIf="data?.AHH_MainObject">
    <tr>
      <td class="font-weight-bold max-w-140">AHH</td>
      <td class="font-weight-bold"> {{ data.AHH_Value }} </td>
      <td>
        <app-rca-tag
          [tagName]="data?.AHH_MainObject"
          [active]="data?.AHH_Dmd_Active"
          [inactive]="data?.AHH_Dmd_InActive"
          [inactiveCount]="data?.AHH_Dmd_InActive_Count"
          [type]="'RCA-D'"></app-rca-tag>
      </td>
      <td>
        <app-rca-tag
          [tagName]="data?.AHH_MainObject"
          [active]="data?.AHH_Ovr_Active"
          [inactive]="data?.AHH_Ovr_InActive"
          [inactiveCount]="data?.AHH_Ovr_InActive_Count"
          [type]="'RCA-O'"></app-rca-tag>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">SD Level:</td>
      <td colspan="2">
        <ng-container *ngIf="data?.AHH_SDL">
          <ng-container *ngFor="let sdl of getSDLs(data.AHH_SDL); let i = index">
            <span class="clickable" (click)="onOpenSDL(sdl)">{{ sdl }}</span>
            <ng-container *ngIf="i < getSDLs(data.AHH_SDL).length - 1">, </ng-container>
          </ng-container>
        </ng-container>
      </td>
      <td>
        <ng-container *ngIf="data.AHH_Sif">
          <a
            [routerLink]="['/spas/sif-manual/overview']"
            [queryParams]=getSIFParams(data.AHH_MainObject)
            title="SIF"
            class="mt-1 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 pe-1 px-1 font-weight-bold"
            target="_blank">
            SIF
          </a>
        </ng-container>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">Barrier function:</td>
      <td colspan="3">
        {{ data.AHH_BarrierFunction }}
      </td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
  </ng-container>

  <!-- AH -->
  <ng-container *ngIf="data?.AH_MainObject">
    <tr>
      <td class="font-weight-bold max-w-140">AH</td>
      <td class="font-weight-bold">{{ data.AH_Value }}</td>
      <td>
        <app-rca-tag
          [tagName]="data?.AH_MainObject"
          [active]="data?.AH_Dmd_Active"
          [inactive]="data?.AH_Dmd_InActive"
          [inactiveCount]="data?.AH_Dmd_InActive_Count"
          [type]="'RCA-D'"></app-rca-tag>
      </td>
      <td>
        <app-rca-tag
          [tagName]="data?.AH_MainObject"
          [active]="data?.AH_Ovr_Active"
          [inactive]="data?.AH_Ovr_InActive"
          [inactiveCount]="data?.AH_Ovr_InActive_Count"
          [type]="'RCA-O'"></app-rca-tag>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">SD Level:</td>
      <td colspan="2">
        <ng-container *ngIf="data?.AH_SDL">
          <ng-container *ngFor="let sdl of getSDLs(data.AH_SDL); let i = index">
            <span class="clickable" (click)="onOpenSDL(sdl)">{{ sdl }}</span>
            <ng-container *ngIf="i < getSDLs(data.AH_SDL).length - 1">, </ng-container>
          </ng-container>
        </ng-container>
      </td>
      <td>
        <ng-container *ngIf="data.AH_Sif">
          <a
            [routerLink]="['/spas/sif-manual/overview']"
            [queryParams]=getSIFParams(data.AH_MainObject)
            title="SIF"
            class="mt-1 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 pe-1 px-1 font-weight-bold"
            target="_blank">
            SIF
          </a>
        </ng-container>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">Barrier function:</td>
      <td colspan="3">
        {{ data.AH_BarrierFunction }}
      </td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
  </ng-container>

  <!-- AL -->
  <ng-container *ngIf="data?.AL_MainObject">
    <tr>
      <td class="font-weight-bold max-w-140">AL</td>
      <td class="font-weight-bold">{{ data.AL_Value }}</td>
      <td>
        <app-rca-tag
          [tagName]="data?.AL_MainObject"
          [active]="data?.AL_Dmd_Active"
          [inactive]="data?.AL_Dmd_InActive"
          [inactiveCount]="data?.AL_Dmd_InActive_Count"
          [type]="'RCA-D'"></app-rca-tag>
      </td>
      <td>
        <app-rca-tag
          [tagName]="data?.AL_MainObject"
          [active]="data?.AL_Ovr_Active"
          [inactive]="data?.AL_Ovr_InActive"
          [inactiveCount]="data?.AL_Ovr_InActive_Count"
          [type]="'RCA-O'"></app-rca-tag>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">SD Level:</td>
      <td colspan="2">
        <ng-container *ngIf="data?.AL_SDL">
          <ng-container *ngFor="let sdl of getSDLs(data.AL_SDL); let i = index">
            <span class="clickable" (click)="onOpenSDL(sdl)">{{ sdl }}</span>
            <ng-container *ngIf="i < getSDLs(data.AL_SDL).length - 1">, </ng-container>
          </ng-container>
        </ng-container>
      </td>
      <td>
        <ng-container *ngIf="data.AL_Sif">
          <a
            [routerLink]="['/spas/sif-manual/overview']"
            [queryParams]=getSIFParams(data.AL_MainObject)
            title="SIF"
            class="mt-1 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 pe-1 px-1 font-weight-bold"
            target="_blank">
            SIF
          </a>
        </ng-container>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">Barrier function:</td>
      <td colspan="3">
        {{ data.AL_BarrierFunction }}
      </td>
    </tr>
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
  </ng-container>

  <!-- ALL -->
  <ng-container *ngIf="data?.ALL_MainObject">
    <tr>
      <td class="font-weight-bold max-w-140">ALL</td>
      <td class="font-weight-bold">{{ data.ALL_Value }}</td>
      <td>
        <app-rca-tag
          [tagName]="data?.ALL_MainObject"
          [active]="data?.ALL_Dmd_Active"
          [inactive]="data?.ALL_Dmd_InActive"
          [inactiveCount]="data?.ALL_Dmd_InActive_Count"
          [type]="'RCA-D'"></app-rca-tag>
      </td>
      <td>
        <app-rca-tag
          [tagName]="data?.ALL_MainObject"
          [active]="data?.ALL_Ovr_Active"
          [inactive]="data?.ALL_Ovr_InActive"
          [inactiveCount]="data?.ALL_Ovr_InActive_Count"
          [type]="'RCA-O'"></app-rca-tag>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">SD Level:</td>
      <td colspan="2">
        <ng-container *ngIf="data?.ALL_SDL">
          <ng-container *ngFor="let sdl of getSDLs(data.ALL_SDL); let i = index">
            <span class="clickable" (click)="onOpenSDL(sdl)">{{ sdl }}</span>
            <ng-container *ngIf="i < getSDLs(data.ALL_SDL).length - 1">, </ng-container>
          </ng-container>
        </ng-container>
      </td>
      <td>
        <ng-container *ngIf="data.ALL_Sif">
          <a
            [routerLink]="['/spas/sif-manual/overview']"
            [queryParams]=getSIFParams(data.ALL_MainObject)
            title="SIF"
            class="mt-1 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 font-weight-bold"
            target="_blank">
            SIF
          </a>
        </ng-container>
      </td>
    </tr>
    <tr>
      <td class="max-w-140">Barrier function:</td>
      <td colspan="3">
        {{ data.ALL_BarrierFunction }}
      </td>
    </tr>
  </ng-container>
  </tbody>
</table>
